import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { TicketingOrbitComponent } from './app/ticketing-orbit.component';

bootstrapApplication(TicketingOrbitComponent, appConfig).catch(err => console.error(err));
